import React from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import ProjectDetailView from "./ProjectDetailView";
import { useParams } from "react-router-dom";
import { caseStudiesData } from "./caseStudiesData";

function CaseStudyDetails() {
  const { id } = useParams();
  const project = caseStudiesData.find((p) => p.id === parseInt(id));

  if (!project) {
    return (
      <div>
        <Header />
        <div style={{ padding: "100px 0", textAlign: "center" }}>
          <h1>Project not found</h1>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <ProjectDetailView project={project} />
      <Footer />
    </div>
  );
}

export default CaseStudyDetails;
